const pagesAppOrgSettingsEn = {
  integrationFeatures: {
    description:
      "Configure the overall integration preferences here. Keep in mind that individual apps may have their own integration settings that can override these general preferences. To fully leverage the advantages of Dress Code, it's recommended to activate all available integration features.",
    disabled: 'Disabled',
    editDialog: {
      cancel: 'Cancel',
      confirmDescription: 'These settings will apply to all the integrations.',
      confirmTitle: 'Are you sure you want to proceed with this action?',
      description:
        'Enabling a integration feature may require re-authentication.',
      disable: 'Disable',
      enable: 'Enable',
      save: 'Save',
      saved: 'Saved successfully',
      title: 'Edit integration features',
      trigger: 'Edit',
    },
    enabled: 'Enabled',
    features: {
      NOTIFICATION: 'Notification & Response',
      USER_LIST: 'User List',
      USER_PROVISIONING: 'User Provisioning',
    },
    resultDialog: {
      close: 'Close',
      description:
        'The integration features may not work if you did not reauthenticate.',
      title: 'Please reauthenticate the following apps',
    },
    title: 'Integration Features',
  },
};

export default pagesAppOrgSettingsEn;
